import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { bodyText, colours } from '../player/playerStyles'

// Sources are named, never reproduced. Only Open Government Licence sources
// are hyperlinked, and then the licence's attribution line is shown.
const FurtherLearning = ({ block, content }) => {
  const sources = content?.course?.sources ?? []
  const items = block.items
    .map((item) => ({ ...item, details: sources.find((source) => source.id === item.source) }))
    .filter((item) => item.details)
  const isLinked = (source) => source.licence === 'OGL' && !!source.url

  return (
    <Box sx={{ maxWidth: '74ch' }}>
      <Box component="ul" sx={{ ...bodyText, m: 0, pl: 3 }}>
        {items.map(({ source, note, details }) => (
          <Box component="li" key={source} sx={{ mb: 1.5 }}>
            {isLinked(details) ? (
              <Box
                component="a"
                href={details.url}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ color: colours.accent, fontWeight: 700, textDecoration: 'underline' }}
              >
                {details.title}
                <Box component="span" sx={{ fontWeight: 400 }}>
                  {' '}
                  (opens in a new tab)
                </Box>
              </Box>
            ) : (
              <Box component="span" sx={{ fontWeight: 700 }}>
                {details.title}
              </Box>
            )}
            <Box component="span" sx={{ display: 'block', color: colours.muted }}>
              {details.publisher}
              {details.year ? `, ${details.year}` : ''}
            </Box>
            {note && (
              <Box component="span" sx={{ display: 'block' }}>
                {note}
              </Box>
            )}
          </Box>
        ))}
      </Box>
      {items.some(({ details }) => isLinked(details)) && (
        <Typography sx={{ fontSize: '1rem', lineHeight: 1.6, color: colours.muted, mt: 2 }}>
          Contains public sector information licensed under the Open Government Licence v3.0.
        </Typography>
      )}
    </Box>
  )
}

export default FurtherLearning
